import { render, staticRenderFns } from "./SelectPageSection.vue?vue&type=template&id=928a6962&"
import script from "./SelectPageSection.vue?vue&type=script&lang=js&"
export * from "./SelectPageSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports